module.exports = __webpack_public_path__ + "assets/media/sobolev_e.f3566f99.jpg";